import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { PlatformDashboardState } from './platform-dashboard.models';

export const selectPlatformDashboardState = createFeatureSelector<PlatformDashboardState>('platformDashboard');

export const selectPlatformDashboardData = createSelector(
  selectPlatformDashboardState,
  (state) => state.data,
);

export const selectPlatformDashboardLoading = createSelector(
  selectPlatformDashboardState,
  (state) => state.loading,
);

export const selectPlatformDashboardError = createSelector(
  selectPlatformDashboardState,
  (state) => state.error,
);
